"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOverlay = exports.OverlayContextProvider = exports.OverlayContext = void 0;
const react_1 = __importDefault(require("react"));
const getScrollbarWidth = () => {
    if (!("document" in globalThis)) {
        return 0;
    }
    const body = document.body;
    const scrollDiv = document.createElement("div");
    scrollDiv.style.height = "50px";
    scrollDiv.style.overflow = "scroll";
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-100px";
    scrollDiv.style.width = "50px";
    body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    body.removeChild(scrollDiv);
    return scrollbarWidth;
};
exports.OverlayContext = react_1.default.createContext({
    mountOverlay: () => 0,
    unmountOverlay: () => { },
    getOverlayZIndex: () => 1
});
const OverlayContextProvider = ({ children }) => {
    const [overlayStack, setOverlayStack] = react_1.default.useState([]);
    react_1.default.useEffect(() => {
        if (overlayStack.length > 0) {
            if (overlayStack.length === 1) {
                document.body.style.paddingInlineEnd = `${getScrollbarWidth()}px`;
                document.body.style.overflow = "hidden";
            }
        }
        else {
            document.body.style.overflow = "";
            document.body.style.paddingInlineEnd = "";
        }
    }, [overlayStack]);
    const mountOverlay = react_1.default.useCallback(() => {
        const newOverlayId = Date.now();
        setOverlayStack((stack) => [...stack, newOverlayId]);
        return newOverlayId;
    }, []);
    const unmountOverlay = react_1.default.useCallback((overlayId) => {
        setOverlayStack((stack) => stack.filter((id) => id !== overlayId));
    }, []);
    const getOverlayZIndex = react_1.default.useCallback((overlayId) => {
        return overlayStack.indexOf(overlayId) + 1;
    }, [overlayStack]);
    return (react_1.default.createElement(exports.OverlayContext.Provider, { value: { mountOverlay, unmountOverlay, getOverlayZIndex } }, children));
};
exports.OverlayContextProvider = OverlayContextProvider;
const useOverlay = () => {
    return react_1.default.useContext(exports.OverlayContext);
};
exports.useOverlay = useOverlay;
//# sourceMappingURL=useOverlay.js.map